import React, { Component } from "react";
import Grid from "./Grid";
import Colour from "./Colour";
import "./App.css";

export default class App extends Component {
  constructor(props) {
    super(props);

    this.handleInvert = this.handleInvert.bind(this);
    this.handleSet = this.handleSet.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleColour = this.handleColour.bind(this);
    this.state = {
      bytes: Array.from({ length: 8 }, (_, i) => i),
      ink: Colour.get("black"),
      paper: Colour.get("white"),
    };
  }

  handleColour(type) {
    return (c) => {
      this.setState({ [type]: Colour.get(c) });
    };
  }

  handleInvert() {
    this.setState({
      bytes: this.state.bytes.map((_) => _ ^ 255),
    });
  }

  handleSet(ti, tv) {
    this.setState({
      bytes: this.state.bytes.map((_, i) => {
        if (i !== ti) return _;
        return tv;
      }),
    });
  }

  handleChange(e) {
    this.setState({
      bytes: e.target.value.split(",").map((_) => parseInt(_.trim(), 10)),
    });
  }

  render() {
    const { bytes } = this.state;
    return (
      <div>
        <style>
          {Colour.colours.map(({ name, hex }) => {
            return `
.paper-${name} .bit { background: ${hex} }
.ink-${name} .bit:checked { background: ${hex} }
`;
          })}
        </style>
        <div className="controls">
          <div className="inline">
            <label>
              <button onClick={this.handleInvert}>Invert</button>
            </label>
            <label>
              <button
                onClick={() => {
                  this.setState({ bytes: Array.from({ length: 8 }, (_) => 0) });
                }}
              >
                Reset
              </button>
            </label>
            <label className="code">
              <textarea
                rows="1"
                cols={bytes.join(",").length}
                className="binary-value"
                onChange={this.handleChange}
                value={bytes.join(",")}
                placeholder="0,0,0,0,0,0"
                ref={(e) => (this.code = e)}
              />
            </label>
          </div>
          <label>
            Ink:
            <Colour
              selected={this.state.ink.index}
              onChange={this.handleColour("ink")}
            />
          </label>
          <label>
            Paper:
            <Colour
              selected={this.state.paper.index}
              onChange={this.handleColour("paper")}
            />
          </label>
        </div>
        <Grid
          className={`ink-${this.state.ink.name} paper-${this.state.paper.name}`}
          grid={bytes}
          set={this.handleSet}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/App.js